module.exports = __webpack_public_path__ + "img/white.24e3572b.jpg";